"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LinkList_1 = require("./LinkList");
exports.default = LinkList_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/LinkList/index.js
// module id = 1779
// module chunks = 8